<template>
	<div>
		<van-tabbar v-model="index" fixed active-color="#8DB9DF" inactive-color="#999999" safe-area-inset-bottom>
			<van-tabbar-item replace to="/">
				<span>首页</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icons[0].active : icons[0].normal"
					class="tabbar_img" />
			</van-tabbar-item>
			<van-tabbar-item replace to="/shop">
				<span>积分商城</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icons[1].active : icons[1].normal"
					class="tabbar_img" />
				<!-- <span>积分商城</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icons[1].active : icons[1].normal"> -->
			</van-tabbar-item>
			<van-tabbar-item replace to="/news">
				<span>消息</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icons[2].active : icons[2].normal"
					class="tabbar_img" />
			</van-tabbar-item>
			<van-tabbar-item replace to="/member">
				<span>我的</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icons[3].active : icons[3].normal"
					class="tabbar_img" />
			</van-tabbar-item>

		</van-tabbar>
		<!-- <div v-if="system==1" class="systemCls"></div> -->
	</div>
</template>
<script>
	export default {
		props: ["active"],
		data() {
			return {
				index: 0,
				icons: [{
					normal: require('../assets/img/tabbar/index0.png'),
					active: require('../assets/img/tabbar/index1.png')
				}, {
					normal: require('../assets/img/tabbar/shop0.png'),
					active: require('../assets/img/tabbar/shop1.png')
				}, {
					normal: require('../assets/img/tabbar/new0.png'),
					active: require('../assets/img/tabbar/new1.png')
				}, {
					normal: require('../assets/img/tabbar/my0.png'),
					active: require('../assets/img/tabbar/my1.png') 
						
				}]
			}
		},
		watch: {
			'$route.meta.tab': {
				handler(newVal, oldVal) {
					this.index = newVal
				},
				deep: true
			}
		},
		mounted() {
			this.index = this.$route.meta.tab;
		},
		methods: {}
		// mounted() {
		// 	this.index = this.active || 0;
		// 	console.log(this);
		// },
	}
</script>

<style lang="less" scoped>
	/deep/.van-tabbar-item__icon img {
		width: 20px;
		height: 20px !important;
	}

	/deep/.van-tabbar {
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 12px 12px 0px 0px;
		// height: 54px;
		// padding-bottom: 30px;
	}

	.van-tabbar-item--active {
		color: @theme-color  !important;
	}
	@supports (bottom: env(safe-area-inset-bottom)) {
		#app {
			padding-bottom: constant(safe-area-inset-bottom);
			padding-bottom: env(safe-area-inset-bottom);
		}
	}

	/deep/.van-tabbar-item {
		font-size: 10px;
	}
</style>
